import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const APP_DOWNLOAD_PROMPT_MAX_DISMISSALS = 3;

interface AppDownloadPromptState {
  dismissCount: number;
  recordDismissal: () => void;
}

export const useAppDownloadPromptStore = create<AppDownloadPromptState>()(
  persist<AppDownloadPromptState>(
    (set) => ({
      dismissCount: 0,
      recordDismissal: () =>
        set((state) => ({ dismissCount: state.dismissCount + 1 })),
    }),
    {
      name: "app-download-prompt",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
